import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PHONE_WHATSAPP } from "@/lib/constants";
import { trackCTAClick } from "@/lib/analytics";

const WhatsAppButton = () => {
  const { t } = useTranslation();
  const message = encodeURIComponent(t("whatsappButton.message"));
  const whatsappUrl = `https://wa.me/${PHONE_WHATSAPP}?text=${message}`;
  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackCTAClick("whatsapp", "floating", "WhatsApp")}
      className="hidden md:inline-flex fixed md:bottom-8 md:right-8 z-50 items-center gap-2 rounded-full bg-success text-success-foreground pl-3 pr-4 py-2.5 shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105"
      aria-label={t("whatsappButton.aria")}
    >
      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-success-foreground/15">
        <MessageCircle className="h-4 w-4" strokeWidth={2} />
      </span>
      <span className="text-sm font-semibold whitespace-nowrap">{t("whatsappButton.label")}</span>
    </a>
  );
};

export default WhatsAppButton;
